import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXListingPhotos implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;

    }
    getPageClass():string{
        return "zidxListingPhotosContainer";
    }
    render(){
        // console.log("listing photos");
    }
}